import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";
import Factory from '@/Factories/Factory';
import Utils from '@/Infrastructure/CustomBindingUtilities';
import { CustomBindingRenderHooks } from '#/DefaultViewExtensionInterfaces';
import AsyncTypeGuards from '@/Utility/AsyncTypeGuards';
import RADApplication from '@/Management/RADApplication';
import MessageBoxViewModel from '@/ViewModels/Controls/MessageBoxViewModel';

type Options = {
    uiGenerator: string;
    locator?: string;
    raw?: any;
    hooks?: CustomBindingRenderHooks;
}

interface ConcreteFactory extends Factory {
    getTuple(): any;
}

export default class FactoryBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.factory = {
            init: (element: HTMLElement, valueAccessor: () => Options, bindings: KnockoutAllBindingsAccessor, view: any, bindingContext: KnockoutBindingContext) => {
                const options = valueAccessor();
                const wrapper = $(element);

                let factory = Factory.createInstance(options.uiGenerator, options, 'DummyControl');
                if (factory == null) {
                    return;
                }

                Utils.registerDisposable(factory, bindings, bindingContext);

                this.triggerHook(options.hooks, 'beforeRender', factory, bindingContext);

                factory.async(() => {
                    if (AsyncTypeGuards.isAsyncTupleProvider<any>(factory)) {
                        factory.getTupleAsync().then(tuple => {
                            wrapper.prepend(tuple.control);
                            this.triggerHook(options.hooks, 'afterRender', factory, bindingContext);
                        }).catch(e => {
                            this.handleError(e);
                            this.triggerHook(options.hooks, 'onFailure', factory, bindingContext, e);
                        });
                    } else {
                        try {
                            const tuple = (factory as ConcreteFactory).getTuple();
                            wrapper.wrapInner(tuple.control);
                            this.triggerHook(options.hooks, 'afterRender', factory, bindingContext);
                        } catch (e) {
                            this.handleError(e);
                            this.triggerHook(options.hooks, 'onFailure', factory, bindingContext, e);
                        }
                    }

                    ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                        if (!factory.isDisposedOrDisposing()) {
                            factory.dispose();
                        }
                        factory = null;
                    });
                });
            }
        };
    }

    private handleError(error?: Error) {
        console.error(error);

        const errorMessageBox = MessageBoxViewModel.createErrorMessageBox(null, 'GENERIC_ERROR', error?.stack);
        RADApplication.getInstance().showMessageBox(errorMessageBox);
    }

    private triggerHook<T extends keyof CustomBindingRenderHooks<Factory>>(
        hooks: CustomBindingRenderHooks<Factory>,
        hookName: T,
        ...params: Parameters<CustomBindingRenderHooks<Factory>[T]>
    ) {
        if (!hooks)
            return;

        const hook = hooks[hookName];
        if (!hook || typeof hook !== 'function')
            return;

        hook(params[0], params[1]);
    }
}